import React from 'react';
export function Footer() {
  return <footer className="py-12 px-4 border-t border-white/10 bg-black text-center text-gray-500 text-sm font-medium" data-id="element-109">
      <div className="max-w-4xl mx-auto space-y-3" data-id="element-110">
        <p className="text-brand-cream font-black text-lg" data-id="element-111">
          KITONLINE™ Italia
        </p>
        <p className="text-gray-400 font-bold" data-id="element-112">
          Risorse d'eccellenza per la Scuola Secondaria.
        </p>
        <p className="text-gray-500 italic" data-id="element-113">
          Perché insegnare Lettere non dovrebbe toglierti i tuoi momenti di
          relax.
        </p>
        <div className="flex flex-wrap justify-center items-center gap-x-4 gap-y-1 pt-2" data-id="element-114">
          <a href="mailto:kitonline27@gmail.com" className="hover:text-brand-orange transition-colors" data-id="element-115">
            📧 kitonline27@gmail.com
          </a>
          <span className="text-gray-700" data-id="element-116">•</span>
          <span data-id="element-117">📲 @kitonline.italia</span>
        </div>
        <p className="pt-2" data-id="element-118">© KITONLINE™ 2026 — Tutti i diritti riservati.</p>
      </div>
    </footer>;
}